import { ApiService } from "@/api";

export const stashAnswer = (
  sampleId: string,
  answer: any,
  backup?: boolean
) => {
  return ApiService.baseAction(
    `answer/cache/${sampleId}`,
    {
      data: answer,
      params: {
        backup,
      },
    },
    "PUT"
  );
};
